export function hasValues(obj: any): boolean {
  // Iterate over the keys in the object
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // Check if the value is non-empty
      if (
        (Array.isArray(value) && value.length > 0) || // Check if it's a non-empty array
        (typeof value === "object" &&
          value !== null &&
          Object.keys(value).length > 0) || // Check if it's a non-empty object
        (typeof value === "string" && value.trim() !== "") ||
        (typeof value === "boolean" && value === true) // Check if it's a non-empty string
      ) {
        return true;
      }
    }
  }
  // Return false if no non-empty values are found
  return false;
}
